import React from "react"

import "./style/Footer.css"

import FooterBack from "../img/footer.png"
import MobileBack from "../img/mobile-footer.png"

import Mail from "../img/mail.png"
import Linkedin from "../img/link.png"
import Github from "../img/Github.png"

const Footer = () => {
    return (
        <div className="footer">
            <div className="hidden">
                <img
                    src={FooterBack}
                    className="footer-bg"
                    alt="footer"
                    draggable={false}
                />
                <img
                    src={MobileBack}
                    className="mobile-footer-bg"
                    alt="footer"
                    draggable={false}
                />
            </div>

            <div className="social-bar">
                <a
                    href="https://github.com/vickyli248"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        src={Github}
                        className="icon"
                        alt="github"
                        draggable={false}
                    />
                </a>
                <a
                    href="https://www.linkedin.com/in/victoriayli/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        src={Linkedin}
                        className="icon"
                        alt="linkedin"
                        draggable={false}
                    />
                </a>
                <h3 className="connect-text">CONNECT WITH ME! I'D LOVE TO CHAT.</h3>
                <a
                    href="mailto: victoria.li@berkeley.edu"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img src={Mail} className="icon" alt="mail" draggable={false} />
                </a>
                
            </div>
        </div>
    )
}
export default Footer
